import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axiosInstance from '../api/axiosInstance';
import './AdminCommon.css';

const MyPage: React.FC = () => {
  const navigate = useNavigate();
  const [currentUser, setCurrentUser] = useState<any>(null);
  const [myContents, setMyContents] = useState<any[]>([]);
  const [myBoards, setMyBoards] = useState<any[]>([]);
  const [myComments, setMyComments] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMyData = async () => {
      try {
        const userRes = await axiosInstance.get('/api/auth/me');
        const user = userRes.data;
        setCurrentUser(user);

        const [contentsRes, boardsRes, commentsRes] = await Promise.all([
          axiosInstance.get('/api/contents', { params: { user_id: user.id } }),
          axiosInstance.get('/api/boards', { params: { user_id: user.id } }),
          axiosInstance.get('/api/comments', { params: { user_id: user.id } })
        ]);

        setMyContents(contentsRes.data);
        setMyBoards(boardsRes.data);
        setMyComments(commentsRes.data);
      } catch (err: any) {
        if (err.response?.status === 401) {
          alert('로그인이 필요합니다.');
          navigate('/login');
        } else {
          console.error('데이터 로딩 실패:', err);
          alert('데이터 로딩에 실패했습니다.');
        }
      } finally {
        setLoading(false);
      }
    };

    fetchMyData();
  }, [navigate]);

  if (loading) {
    return (
      <div className="admin-page-wrapper" style={{ textAlign: 'center', padding: '48px 0' }}>
        <div style={{ color: 'var(--admin-text-muted)', fontSize: '16px' }}>개인 활동 요약 불러오는 중...</div>
      </div>
    );
  }

  return (
    <div className="admin-page-wrapper">
      <div className="admin-page-header" style={{ marginBottom: '40px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          <div className="profile-avatar-circle" style={{ width: '60px', height: '60px', margin: 0, boxShadow: 'none' }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
              <circle cx="12" cy="7" r="4"></circle>
            </svg>
          </div>
          <div>
            <h2 className="admin-page-title" style={{ fontSize: '24px' }}>마이페이지</h2>
            {currentUser && (
              <div className="admin-page-subtitle" style={{ fontSize: '14px', marginTop: '2px' }}>
                안녕하세요, <strong style={{ color: 'var(--admin-primary)', fontWeight: 600 }}>{currentUser.username}</strong>님! 오늘도 멋진 아카이빙을 즐겨보세요.
              </div>
            )}
          </div>
        </div>
        <Link to="/profile" className="admin-btn admin-btn-secondary" style={{ textDecoration: 'none' }}>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 20h9"></path>
            <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path>
          </svg>
          프로필 편집
        </Link>
      </div>

      {/* 내가 작성한 콘텐츠 섹션 */}
      <div style={{ marginBottom: '44px' }}>
        <h3 className="admin-section-title" style={{ borderLeft: '4px solid var(--admin-primary)', paddingLeft: '12px' }}>
          내가 기여한 역사 콘텐츠
          <span className="section-count-badge">{myContents.length}</span>
        </h3>
        
        {myContents.length === 0 ? (
          <div className="admin-empty-state">
            <svg className="admin-empty-icon" xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
              <polyline points="14 2 14 8 20 8"></polyline>
              <line x1="16" y1="13" x2="8" y2="13"></line>
              <line x1="16" y1="17" x2="8" y2="17"></line>
              <polyline points="10 9 9 9 8 9"></polyline>
            </svg>
            <div style={{ fontWeight: 600, fontSize: '14px', color: 'var(--admin-text-main)', marginBottom: '2px' }}>아직 기여한 콘텐츠가 없습니다.</div>
            <div style={{ fontSize: '12px' }}>시간 축에 새로운 역사적 사건을 직접 추가해 기여해 보세요.</div>
          </div>
        ) : (
          <ul className="admin-card-list">
            {myContents.map(c => (
              <li key={c.id} className="admin-card-item" style={{ borderLeft: '4px solid var(--admin-primary)' }}>
                <Link to={`/content/${c.id}`} className="admin-card-link">
                  <div style={{ fontWeight: '600', fontSize: '15px', marginBottom: '6px', color: 'var(--admin-text-main)' }}>
                    {c.title}
                  </div>
                  <div style={{ fontSize: '12px', color: 'var(--admin-text-muted)', display: 'flex', alignItems: 'center', gap: '4px' }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <circle cx="12" cy="12" r="10"></circle>
                      <polyline points="12 6 12 12 16 14"></polyline>
                    </svg>
                    {new Date(c.created_at).toLocaleString()}
                  </div>
                </Link>
              </li>
            ))}
          </ul>
        )}
      </div>

      {/* 내가 작성한 게시글 섹션 */}
      <div style={{ marginBottom: '44px' }}>
        <h3 className="admin-section-title" style={{ borderLeft: '4px solid var(--admin-success)', paddingLeft: '12px' }}>
          작성한 토론/질문 게시글
          <span className="section-count-badge">{myBoards.length}</span>
        </h3>
        
        {myBoards.length === 0 ? (
          <div className="admin-empty-state">
            <svg className="admin-empty-icon" xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
            </svg>
            <div style={{ fontWeight: 600, fontSize: '14px', color: 'var(--admin-text-main)', marginBottom: '2px' }}>작성된 토론 게시글이 없습니다.</div>
            <div style={{ fontSize: '12px' }}>댓글 또는 토론방에서 역사적 쟁점에 대해 의견을 개진해 보세요.</div>
          </div>
        ) : (
          <ul className="admin-card-list">
            {myBoards.map(b => (
              <li key={b.id} className="admin-card-item" style={{ borderLeft: '4px solid var(--admin-success)' }}>
                <Link to={`/boards/${b.category}/${b.id}`} className="admin-card-link">
                  <div style={{ fontWeight: '600', fontSize: '15px', marginBottom: '6px', color: 'var(--admin-text-main)', display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <span>{b.title}</span>
                    {b.is_pinned && <span className="admin-badge admin-badge-danger" style={{ padding: '2px 6px', fontSize: '10px' }}>공지</span>}
                  </div>
                  <div style={{ fontSize: '12px', color: 'var(--admin-text-muted)', display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <span style={{ fontWeight: 500, color: 'var(--admin-success)' }}>{b.category}</span>
                    <span style={{ color: '#cbd5e1' }}>•</span>
                    <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <circle cx="12" cy="12" r="10"></circle>
                        <polyline points="12 6 12 12 16 14"></polyline>
                      </svg>
                      {new Date(b.created_at).toLocaleString()}
                    </span>
                  </div>
                </Link>
              </li>
            ))}
          </ul>
        )}
      </div>

      {/* 내가 작성한 댓글 섹션 */}
      <div>
        <h3 className="admin-section-title" style={{ borderLeft: '4px solid var(--admin-warning)', paddingLeft: '12px' }}>
          작성한 피드백 댓글
          <span className="section-count-badge">{myComments.length}</span>
        </h3>
        
        {myComments.length === 0 ? (
          <div className="admin-empty-state">
            <svg className="admin-empty-icon" xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path>
            </svg>
            <div style={{ fontWeight: 600, fontSize: '14px', color: 'var(--admin-text-main)', marginBottom: '2px' }}>남겨진 피드백 댓글이 없습니다.</div>
            <div style={{ fontSize: '12px' }}>콘텐츠 설명 혹은 질문글 하단에 따뜻한 조언이나 평가를 남겨주세요.</div>
          </div>
        ) : (
          <ul className="admin-card-list">
            {myComments.map(cm => {
              const linkPath = cm.comment_type === 'content' 
                ? `/content/${cm.content_id}` 
                : `/boards/${cm.category}/${cm.board_id}`;
              
              return (
                <li key={`${cm.comment_type}-${cm.id}`} className="admin-card-item" style={{ borderLeft: '4px solid var(--admin-warning)' }}>
                  <Link to={linkPath} className="admin-card-link">
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                      <div style={{ fontWeight: '600', color: 'var(--admin-warning)', fontSize: '13px', display: 'flex', alignItems: 'center', gap: '6px' }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path>
                          <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path>
                        </svg>
                        "{cm.parent_title}" 원글 관련 댓글
                      </div>
                      <div style={{ color: 'var(--admin-text-main)', fontSize: '15px', fontWeight: 500, margin: '4px 0' }}>
                        {cm.comment}
                      </div>
                    </div>
                    <div style={{ fontSize: '12px', color: 'var(--admin-text-muted)', display: 'flex', alignItems: 'center', gap: '12px', marginTop: '4px' }}>
                      <span style={{ fontWeight: 600 }}>{cm.comment_type === 'content' ? '아카이브' : '자유게시판'}</span>
                      <span style={{ color: '#cbd5e1' }}>•</span>
                      <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <circle cx="12" cy="12" r="10"></circle>
                          <polyline points="12 6 12 12 16 14"></polyline>
                        </svg>
                        {new Date(cm.created_at).toLocaleString()}
                      </span>
                    </div>
                  </Link>
                </li>
              );
            })}
          </ul>
        )}
      </div>
    </div>
  );
};

export default MyPage;
